import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import global from "../../config";
import Card from "../../UI/Card";
import Header from "../Header/Header";
import "./ManageCreators.css";
import ContextMenu from "./ContextMenu";
import Loader from "../../UI/Loader";
import ConfirmationDialog from "../../UI/ConfirmationDialog";

export default function ManageCreators(props) {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [listData, setListData] = useState({});
  const [searchText, showSearchText] = useState("");
  const [submitSearch, showSubmitSearch] = useState(false);
  const [addFormDialog, setAddFormDialog] = useState(false);
  const [records, setRecords]=useState('')
  const [totalRecord, setTotalRecord]=useState(0);
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [percentagePackaged, setPercentagePackaged] = useState(0);
  const [percentageMetaData, setPercentageMetaData] = useState(0);
  const [deleteResponse, setDeleteResponse] = useState("");

  // [Start of Context Menu Option]
  const [actionID, setActionID] = useState("");
  const [toggleActionBlock, setToggleAction] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const toggleAction = () => {
    setToggleAction(!toggleActionBlock);
  };
  const editClickHandler = () => {
    toggleAction();
    navigate(`/admin/creator/edit/${actionID}`)
  };
  const deleteClickHandler = () => {
    setShowConfirm(true);
    toggleAction();
  };
  const clickHandler = (id) => {
    toggleAction();
    setActionID(id);
  };

  const onCancelClick = () => {
    setShowConfirm(false);
    setDeleteResponse("");
  };

  const onDeleteConfirmClick = async () => {
    const idToken = localStorage.getItem("idToken");
    const payLoad = { operation: "delete", CreatorID: actionID };
    const response = await axios.post(global.apiURL + "/creators", payLoad, {
      headers: { Authorization: "Bearer " + idToken },
    });

    if (response && response.status === 200) {
      setDeleteResponse(response.data);
      setShowConfirm(false);
      if(!response.data.error)
      {
        window.location.reload();
      }
    }
  };
  // [End of Context Menu Option]

  // [Start of Add]
  const addData = () => {
    // setActionID("");
    // setAddFormDialog(!addFormDialog);
    navigate("/admin/creator/add");
  };

  const goToDetails = (creatorID)=>{
    navigate(`/admin/shows/${creatorID}`);
  }

  const addErrorHandler = () => {
    setAddFormDialog(addFormDialog);
  };

  const editForm = (userID) => {
    setAddFormDialog(!addFormDialog);
  };
  // [End of Add]

  // [Start of Search]
  const txtValue = (e) => {
    if (e.target.name === "txtSearch") {
      showSearchText(e.target.value);
    }
  };
  const clickSerach = () => {
    setShowLoader(true);
    showSubmitSearch(true);
  };
  const keyUpSearch = (e) => {
    if (e.target.value.length === 0 || e.key === "Enter") {
      clickSerach();
    }
  };

  const getData = async () => {
    const idToken = localStorage.getItem("idToken");

    const payLoad = { operation: "list" };
    if (idToken) {
      const response = await axios.post(global.apiURL + "/creators", payLoad, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        setListData(response.data.data);
        setRecords(response.data.data);
      } else {
        navigate("/");
      }
    }
    setShowLoader(false);
    showSubmitSearch(false);
  };

  useEffect(() => {
    getData();
  }, [submitSearch]);

  useEffect(() => {
    let sumCount =0;
    let sumAssets = 0;
    let sumFileSize = 0;
    let sumDuration = 0;
    let countPackaged = 0;
    let countMetaData = 0;
    let totalMetadata = records?.length;

    console.log(records);
    if(records && records.length>0)
    {
      records.forEach(record => {
        sumCount = sumCount +1;
        // sumAssets += (record.CreatorAssets?.length > 0 ? record.CreatorAssets?.length : 0);
        // sumFileSize += record.CreatorFileSize?.length > 0 ? (record.CreatorFileSize?.reduce((acc, val) => acc + val, 0)) : 0;
        // sumDuration += record.CreatorDuration?.length>0  ? (record.CreatorDuration?.reduce((acc, val) => acc + val, 0) ) : 0;
        sumAssets +=
          record.assetCount > 0 ? record.assetCount : 0;
        sumFileSize +=record.totalFileSize;
        sumDuration +=record.totalDuration;
        if(record.assetCount===0) totalMetadata--;
        if (record.packaged) countPackaged++;
        if (record.metadata) countMetaData++;
      });
  }
    setTotalRecord(sumCount);
    setTotalAssets(sumAssets);
    setTotalFileSize(sumOfFileSizes([sumFileSize]));
    setTotalDuration(sumOfCreatorDuration([sumDuration]));
    setPercentagePackaged(((countPackaged / records.length) * 100).toFixed(2));
    setPercentageMetaData(((countMetaData / totalMetadata) * 100).toFixed(2));
  }, [records]); 

  // [End of Search]

  const sumOfFileSizes = (fileSizes) => {
    if (!fileSizes || fileSizes.length === 0) {
      return 0;
    }
    const sumInBytes = fileSizes.reduce(
      (acc, size) => acc + parseInt(size, 10),
      0
    );
    const bytesPerGB = 1073741824;
    const sumInGB = sumInBytes / bytesPerGB;
    return Number(sumInGB.toFixed(2));
  };

  const sumOfCreatorDuration = (durations) => {
    if (!durations || durations.length === 0) {
      return "0 M";
    }
    const sumInSeconds = durations.reduce(
      (acc, duration) => acc + parseFloat(duration),
      0
    );

    const hours = Math.floor(sumInSeconds / 3600);
    const minutes = Math.floor((sumInSeconds % 3600) / 60);

    if (hours === 0) {
      return `${minutes} M`;
    } else {
      return `${hours} H ${minutes} M`;
    }
  };

  const renderData = (data, serial) => {
    return (
      <Card>
        <div className="card-column">{serial}</div>
        <div className="card-column-large card-column-clickable" onClick={() => goToDetails(data._id)}>{data.CreatorName}</div>
        {/* <div className="card-column-large">{data.CreatorSlug}</div> */}
        <div className="card-column">{data.assetCount}</div>
        <div className="card-column">
          {sumOfFileSizes([data.totalFileSize])} GB
        </div>
        <div className="card-column">
          {sumOfCreatorDuration([data.totalDuration])}
        </div>
        <div className="card-column">
          {data.assetCount > 0 ? (
            data.packaged === true ? (
              <i className="learning-icon icon-yes">&#xe901;</i>
            ) : (
              <i className="learning-icon icon-no">&#xe900;</i>
            )
          ) : (
            "--"
          )}
        </div>
        <div className="card-column">
          {data.assetCount > 0 ? (
            data.metadata === true ? (
              <i className="learning-icon icon-yes">&#xe901;</i>
            ) : (
              <i className="learning-icon icon-no">&#xe900;</i>
            )
          ) : (
            "--"
          )}
        </div>
        <div>
          <button
            className="action-button"
            type="button"
            onClick={() => clickHandler(data._id)}
          >
            <i className="learning-icon icon-more">&#xe902;</i>
          </button>
        </div>
        {actionID === data._id && toggleActionBlock === true && (
          <ContextMenu
            id={data._id}
            onEditClick={editClickHandler}
            onDeleteClick={deleteClickHandler}
          />
        )}
      </Card>
    );
  };

  return (
    <>
      <div class="wrap-over-container">
        <Header />
        {showConfirm === true && (
          <ConfirmationDialog
            title="Delete Creator"
            description="Are you sure you want to delete?"
            onCancelClick={onCancelClick}
            onSubmitClick={onDeleteConfirmClick}
            submitButtonText="Delete"
            cancelButtonText="Cancel"
          />
        )}
        {deleteResponse.error && (
          <ConfirmationDialog
            title="Error Deleting a Creator"
            description={deleteResponse.error}
            onSubmitClick={onCancelClick}
            submitButtonText="Close"
          />
        )}

        {deleteResponse.message && (
          <ConfirmationDialog
            title="Delete Successful"
            description={deleteResponse.message}
            onSubmitClick={onCancelClick}
            submitButtonText="Close"
          />
        )}
        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader">
                <h3>Creators</h3>
                <div className="admin-panel-header-right">
                  {/* <div className='adsearch'>
                                    <input type='text'  onChange={txtValue} onKeyUp={keyUpSearch} name='txtSearch' placeholder='Search creator by code' autoComplete="new-password"  />
                                    <button type='button' className='search' onClick={clickSerach} ><i className='learning-icon'>&#xe900;</i></button>
                                </div> */}

                  <button type="button" className="add" onClick={addData}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.01761 7.0176L7.01761 0.00201581L9.02165 0.00201598L9.02165 7.0176L16.0372 7.0176V9.02165L9.02165 9.02165L9.02165 16.0372L7.01761 16.0372L7.01761 9.02165L0.0020236 9.02165V7.0176L7.01761 7.0176Z"
                        fill="#FFFFFF"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="adbody">
                {showLoader === true && (
                  <div style={{ height: "70vh", position: "relative" }}>
                    <Loader />
                  </div>
                )}
                {showLoader === false && (
                  <>
                    <Card type="header">
                      <div className="card-column-stats">{totalRecord} <br/> CREATORS</div>
                      <div className="card-column-stats">{totalAssets} <br/> ASSETS</div>
                      <div className="card-column-stats">{totalFileSize} GB <br/> FILESIZE</div>
                      <div className="card-column-stats">{totalDuration} <br/> DURATION</div>
                      <div className="card-column-stats">{percentageMetaData}% <br/> COMPLETE</div>
                    </Card>

                    <Card type="header">
                      <div className="card-column">#</div>
                      <div className="card-column-large">CREATOR NAME</div>
                      {/* <div className="card-column-large">Creator Slug</div> */}
                      <div className="card-column">ASSETS</div>
                      <div className="card-column">FILESIZE</div>
                      <div className="card-column">DURATION</div>
                      <div className="card-column">PACKAGED</div>
                      <div className="card-column">METADATA</div>
                      {/* <div className="card-column">Created On</div> */}
                      <div className="card-column-auto">ACTION</div>
                    </Card>
                    {listData.map((data, index) => (
                      <div key={data.CreatorCode}>
                        {renderData(data, index + 1)}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
}
